
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import CREATE_USER_EDUCATION from "@/apollo/profile/educations/CreateEducation.gql";
import UPDATE_USER_EDUCATION from "@/apollo/profile/educations/UpdateEducation.gql";

import FormGroup from "@/components/form/FormGroupNew.vue";
import FormDatepicker from "@/components/form/FormDatepickerNew.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import UIButton from "@/components/button/ui-button.vue";

import { User_Education } from "@/generated/graphql";
import { NOTIFICATION } from "@/entities/Events";
import Message from '@/data/notificationsMessages';

@Component({
    components: {
        FormDatepicker,
        FormTextarea,
        FormGroup,
        UIButton,
    },
    model: {
        prop: "showDialog",
        event: "toggle",
    },
})
export default class EducationForm extends Vue {
    @Prop({ type: Object, default: undefined }) readonly education?: User_Education;
    @Prop({ type: String, required: true }) readonly userId!: string;
    @Prop({ type: Boolean, default: false }) readonly showDialog!: boolean;
    @Prop({ type: String, required: true}) readonly currentUserId!: string;

    id?: string = undefined;
    title: string = "";
    institution: string = "";
    summary: string = "";
    startDate: string | null = null;
    endDate: string | null = null;
    processing: boolean = false;

    @Watch("education", { immediate: true })
    watchProfile(education: User_Education): void {
        this.id = education?.id;
        this.title = education?.title ?? "";
        this.institution = education?.institution ?? "";
        this.summary = education?.summary ?? "";
        this.startDate = education?.start_date ?? null;
        this.endDate = education?.end_date ?? null;
    }

    get modalTitle(): string {
        const prefix = this.isEditing ? "Edit" : "Add";
        return `${prefix} Education`;
    }

    get isEditing(): boolean {
        return Boolean(this.education);
    }

    get educationSet(): Partial<User_Education> {
        return {
            user_id: this.userId,
            title: this.title,
            institution: this.institution,
            start_date: this.startDate,
            end_date: this.endDate,
            summary: this.summary,
            added_by_id: this.currentUserId
        };
    }

    closeModal(): void {
        this.$emit("toggle", false);
    }

    async submit(): Promise<void> {
        this.processing = true;
        try {
            if (this.isEditing) {
                await this.update();
            } else {
                await this.create();
            }

            const successMessage = this.isEditing
                ? `${this.institution} was successfully updated.`
                : `${this.institution} added to your education.`;
            this.$eventBus.emit(
                NOTIFICATION,
                Message.successMessage(successMessage)
            );
        } catch (error) {
            var msg = "";
            if (error instanceof Error) {
                msg = error.message;
            } else {
                msg = error as string;
            }
            this.$eventBus.emit(
                NOTIFICATION,
                Message.errorMessage(msg)
            );
        } finally {
            this.closeModal();
        }
        this.processing = false;
    }

    async create(): Promise<void> {
        await this.$apollo.mutate({
            mutation: CREATE_USER_EDUCATION,
            variables: {
                educationSet: this.educationSet,
            },
        });
        this.$emit("added");
    }

    async update(): Promise<void> {
        await this.$apollo.mutate({
            mutation: UPDATE_USER_EDUCATION,
            variables: {
                educationSet: this.educationSet,
                id: this.id,
            },
        });
        this.$emit("updated");
    }
}
